module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/arrow_prev-a5678f8b7c1e8ac2c59e5abd2ff3a3e3.svg";